export function sortNumericIds(ids) {
    return [...ids].sort((a, b) => a - b);
}

export function getQuestionById(questions, id) {
    return questions.find((q) => q.questionId === id);
}

export function findMatchingRecommendations(recommendations, selectedAnswerIds) {
    const sortedSelected = sortNumericIds(selectedAnswerIds);

    return recommendations.find((rec) => {
        const sortedRec = sortNumericIds(rec.answerIds);

        return (
            sortedRec.length === sortedSelected.length &&
            sortedRec.every((val, index) => val === sortedSelected[index])
        );
    });
}